import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './eligibilityAdmission.component.html',
	styleUrls: ['./eligibilityAdmission.component.css']
})

export class EligibilityAdmissionComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/admission/eligibilityAdmission.component.ts